// extracted by mini-css-extract-plugin
export var infoRow = "_tz-2";
export var labelContainer = "_tz-0";
export var rightInfo = "_tz-1";